import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

// Define a type for the slice state
interface CounterState {
    loading: boolean
}

// Define the initial state using that type
const initialState: CounterState = {
    loading: false,
}

export const utilSlice = createSlice({
    name: 'util',
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },
        logout(state) {
            localStorage.removeItem("token")
            localStorage.removeItem("user")
            localStorage.removeItem("selectedStudent")
        },
    },
})

export const { setLoading, logout } = utilSlice.actions


export default utilSlice.reducer